import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";

import Tooltip from './Tooltip';

function ConnectedTooltipWrapper({ isTooltipEnabled, tooltip, dimension }) {
  const [style, setStyle] = useState({});
  useEffect(() => {
    const el = document.getElementById(`left-drawer`);
    if (el) {
      setStyle({ left: el.getBoundingClientRect().left });
    }
  }, [dimension]);

  return (isTooltipEnabled && dimension.fullHeight) ? <Tooltip {...tooltip} isVisible={!!tooltip} style={style} /> : null;
}

const TooltipWrapper = connect(
  state => ({
    isTooltipEnabled: state.isTooltipEnabled,
    tooltip: state.tooltip,
    dimension: state.dimension
  })
)(ConnectedTooltipWrapper);

export default TooltipWrapper;
